<template>
  <div>
    <div class="show1Box moduleBox">
      <div class="show1">
        <div class="show1_title">
          <div class="text_blue_color">结算确认</div>
          <div @click="hiddenSettlement()">x</div>
        </div>
        <div class="show1_content">
          <div>确认结算当前策略？</div>
        </div>
        <div class="show1_foot">
          <button class="button_blue_color" @click="operationSettlement()">确认</button>
        </div>
      </div>
    </div>
    <el-dialog title="对账单" :visible.sync="capitalState">
      <el-table
        height="500px"
        size="small"
        border
        :data="capitalData"
        stripe
        style="width: 100%">
        <el-table-column
          type="index"
          align="center"
          width="50">
        </el-table-column>
        <el-table-column
          prop="time"
          label="时间"
          align="center">
        </el-table-column>
        <el-table-column
          prop="name"
          label="股票"
          align="center">
        </el-table-column>
        <el-table-column
          prop="type"
          label="类型"
          align="center">
        </el-table-column>
        <el-table-column
          prop="number"
          label="金额"
          align="center">
        </el-table-column>
        <el-table-column
          prop="balance"
          label="余额"
          align="center">
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" class="button_blue_color" @click="capitalState = false">确 定</el-button>
      </span>
    </el-dialog>
    <div class="show4Box moduleBox">
      <div class="show4">
        <div class="show2_title">
          <div class="text_blue_color">追加保证金</div>
          <div @click="hiddenBondAdd()">x</div>
        </div>
        <div class="show2_content">
          <p class="show_content_strategynow_colored">
            <span>当前总账户余额 ：{{cashBondInfo}}元</span><br>
            <span>当前子账户余额 ：{{balance}}元</span><br>
            <span>当前亏损警戒线(亏损比）:{{warningIncreaseBondInfo}}元 <span class="percentageColor">（-{{warning_line_ratio_increase_bond_info}}）</span></span><br>
            <span>当前亏损平仓线(亏损比）:{{closeIncreaseBondInfo}}元 <span class="percentageColor">（-{{close_line_ratio_increase_bond_info}}）</span></span>
          </p>
          <div class="strategynow_matching_amt">
            <img src="../assets/img/sell_get.png">
            <input oninput="value=value.replace(/[^0-9.]/g,'')" style="width: 200px;" type="digit" v-model="addBondMoney" placeholder="请输入追加金额 最低100元起">
          </div>
          <p class="show_content_strategynow">
            <span>追加后总账户余额 ：{{afterCashBondInfo}}元 </span><br>
            <span>追加后子账户余额 :{{balanceAfter}}元 </span><br>
            <span>追加后亏损警戒线（亏损比）:{{warningIncreaseBondInfo}}元 <span class="percentageColor">（-{{warning_line_ratio_increase_bond_info_after}}%）</span></span><br>
            <span>追加后亏损平仓线（亏损比）:{{closeIncreaseBondInfo}}元 <span class="percentageColor">（-{{close_line_ratio_increase_bond_info_after}}%）</span></span>
          </p>
        </div>
        <div class="show2_foot">
          <button class="button_blue_color" @click="operationBondAdd()">确认</button>
        </div>
      </div>
      </div>
      <div class="show3Box moduleBox">
      <div class="show3">
        <div class="show2_title">
          <div class="text_blue_color">追加配资</div>
          <div @click="hiddenAdd()">x</div>
        </div>
        <div class="show2_content">
          <p class="show_content_strategynow_colored">
          <span>当前总账户余额 ：{{cashCapitalInfo}}元</span><br>  
          <span>当前子账户余额 ：{{balance}}元 </span><br>
          <span>当前亏损警戒线(亏损比）:{{warningIncreaseInfo}}元 <span class="percentageColor">（-{{warning_line_ratio_increase_info}}）</span></span><br>
          <span>当前亏损平仓线(亏损比）:{{closeIncreaseInfo}}元 <span class="percentageColor">（-{{close_line_ratio_increase_info}}）</span></span>
          </p>
          <div class="strategynow_matching_amt">
            <img src="../assets/img/sell_get.png">
            <input oninput="value=value.replace(/[^0-9.]/g,'')" style="width: 200px;" type="digit" v-model="addMoney" placeholder="请输入追加金额 最低100元起">
          </div>
          <p class="show_content_strategynow">
            <span>追加后总账户余额 ：{{afterCashCapitalInfo}}元</span><br>
            <span>追加后子账户余额 :{{balanceAfter}}元 </span><br>
            <span>追加后亏损警戒线（亏损比）:{{warningIncreaseInfoAfter}}元 <span class="percentageColor">（-{{warning_line_ratio_increase_info_after}}%）</span></span><br>
            <span>追加后亏损平仓线（亏损比）:{{closeIncreaseInfoAfter}}元 <span class="percentageColor">（-{{close_line_ratio_increase_info_after}}%）</span></span>
          </p>
        </div>
        <div class="show2_foot">
          <button class="button_blue_color" @click="operationAdd()">确认</button>
        </div>
      </div>
    </div>
    <el-row>
      <el-col :span="18" id="capitaldatadropdown">
        <el-select v-model="operateData" placeholder="请选择账户" style="width: 100%" @change="changeOperate(operateData)">
          <el-option v-for="item in operateOptions" :key="item.cid"
            :label="item.name + '(' + item.order + ')' + ' 余额:' + item.use" :value="item.cid">
          </el-option>
        </el-select>
      </el-col>

      <el-col :span="4" id="proportion">
        <span v-if="selectedAccount" v-bind:class="[selectedAccount.proportion >= 0 ? 'redText' : 'greenText']">
          {{ selectedAccount.proportion }}%
        </span>
      </el-col>
      <el-col :span="2" id="refreshBtn">
        <el-button @click="refreshData()" size="small"><i class="el-icon-refresh"></i></el-button>
      </el-col>
    </el-row>
    <el-tabs
      type="border-card"
      stretch
      v-model="tabsName"
      @tab-click="handleClick"
    >
      <el-tab-pane label="买入" name="buyStock">
        <el-row :gutter="10">
          <el-col :span="14">
            <el-form label-width="0" :model="stockBuy" size="medium">
              <el-form-item>
                <el-select
                  v-model="stockBuy.info"
                  filterable
                  remote
                  :remote-method="remoteMethod"
                  :loading="loading"
                  placeholder="代码/名称/简拼"
                  @change="changeInfo('buy', true); openDetailed($event)"
                  size="small"
                  class="full_width"
                >
                  <el-option
                    v-for="item in options"
                    :key="item.short"
                    :label="item.name + ' ' + item.short"
                    :value="item.short"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item style="margin-bottom: 0">
                <el-row>
                  <el-col :span="8">
                    <el-button
                      type="danger"
                      @click="changePrice('buy')"
                      v-if="changeBuyType"
                      size="small"
                      class="full_width button_red_color"
                      >市价</el-button
                    >
                    <el-button
                      type="danger"
                      @click="changePrice('buy')"
                      v-else
                      size="small"
                      class="full_width button_red_color"
                      >限价</el-button
                    >
                  </el-col>
                  <el-col :span="16">
                    <el-input
                      :disabled="true"
                      v-if="changeBuyType"
                      size="small"
                      class="full_width"
                      placeholder="市价买入"
                    ></el-input>
                    <el-input
                      v-model="stockBuy.limitPrice"
                      v-else
                      size="small"
                      class="full_width"
                      placeholder="买入价"
                    ></el-input>
                  </el-col>
                </el-row>
                <p>
                  涨停价:<span class="text_red_color">{{ stockBuy.hardenPrice }}</span
                  >&nbsp;&nbsp;&nbsp;跌停价:<span class="text_red_color">{{
                    stockBuy.dropPrice
                  }}</span>
                </p>
              </el-form-item>
              <el-form-item style="margin-bottom: 0">
                <el-input
                  v-model="stockBuy.number"
                  size="small"
                  type="number"
                  placeholder="买入量"
                ></el-input>
                <p v-if="changeBuyType">
                  可买<span class="text_red_color">{{ buyMarketPrice }}</span
                  >股
                </p>
                <p v-else>
                  可买<span class="text_red_color">{{ buyLimitPrice }}</span
                  >股
                </p>
              </el-form-item>
              <el-form-item>
                <el-row>
                  <el-col :span="6">
                    <el-button
                      class="full_width optionsBuy"
                      size="small"
                      @click="position('buyFull')"
                      >全仓</el-button
                    >
                  </el-col>
                  <el-col :span="6">
                    <el-button
                      class="full_width optionsBuy"
                      size="small"
                      @click="position('buyThreeFourths')"
                      >3/4</el-button
                    >
                  </el-col>
                  <el-col :span="6">
                    <el-button
                      class="full_width optionsBuy"
                      size="small"
                      @click="position('buyTwoFourths')"
                      >1/2</el-button
                    >
                  </el-col>
                  <el-col :span="6">
                    <el-button
                      class="full_width optionsBuy"
                      size="small"
                      @click="position('buyOneFourths')"
                      >1/4</el-button
                    >
                  </el-col>
                </el-row>
              </el-form-item>
              <el-form-item label-width="0">
                <el-button type="danger submit" class="button_red_color" size="small" @click="buyStock"
                  >买入</el-button
                >
              </el-form-item>
            </el-form>
          </el-col>
          <el-col :span="10">
            <el-card class="box-card" shadow="never">
              <el-row>
                <div
                  class="center box-market"
                  v-for="(item, index) in stockBuy.sellArr"
                  :key="index"
                >
                  <el-col :span="8">{{ item.id }}</el-col>
                  <el-col :span="8">{{ item.price }}</el-col>
                  <el-col :span="8">{{ item.number }}</el-col>
                </div>
              </el-row>
            </el-card>
            <el-card class="box-card" shadow="never" style="margin-top: 10px">
              <el-row>
                <p
                  class="center box-market"
                  v-for="(item, index) in stockBuy.buyArr"
                  :key="index"
                >
                  <el-col :span="8">{{ item.id }}</el-col>
                  <el-col :span="8">{{ item.price }}</el-col>
                  <el-col :span="8">{{ item.number }}</el-col>
                </p>
              </el-row>
            </el-card>
          </el-col>
          <el-col :span="24">
            <el-table
              :data="holdData"
              stripe
              height="240px"
              @row-click="buyHanddle"
              size="small"
              style="width: 100%"
            >
              <el-table-column label="名称/市值" align="center">
                <template slot-scope="scope">
                  <div v-if="scope.row.profitMarket.substr(0, 1) === '-'">
                    <p class="green">{{ scope.row.name }}</p>
                    <p class="green">{{ scope.row.market }}</p>
                  </div>
                  <div v-else>
                    <p class="text_red_color">{{ scope.row.name }}</p>
                    <p class="text_red_color">{{ scope.row.market }}</p>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="持仓/可用" align="center">
                <template slot-scope="scope">
                  <div v-if="scope.row.profitMarket.substr(0, 1) === '-'">
                    <p class="green">{{ scope.row.number }}</p>
                    <p class="green">{{ scope.row.sellable }}</p>
                  </div>
                  <div v-else>
                    <p class="text_red_color">{{ scope.row.number }}</p>
                    <p class="text_red_color">{{ scope.row.sellable }}</p>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="现价/均价" align="center">
                <template slot-scope="scope">
                  <div v-if="scope.row.profitMarket.substr(0, 1) === '-'">
                    <p class="green">{{ scope.row.newPrice }}</p>
                    <p class="green">{{ scope.row.price }}</p>
                  </div>
                  <div v-else>
                    <p class="text_red_color">{{ scope.row.newPrice }}</p>
                    <p class="text_red_color">{{ scope.row.price }}</p>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="总盈亏" align="center">
                <template slot-scope="scope">
                  <div v-if="scope.row.profitMarket.substr(0, 1) === '-'">
                    <p class="green">{{ scope.row.profitMarket }}</p>
                    <p class="green">{{ scope.row.priceRatio }}%</p>
                  </div>
                  <div v-else>
                    <p class="text_red_color">{{ scope.row.profitMarket }}</p>
                    <p class="text_red_color">{{ scope.row.priceRatio }}%</p>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
      </el-tab-pane>
      <el-tab-pane label="卖出" name="sellStock">
        <el-row :gutter="10">
          <el-col :span="14">
            <el-form :model="stockSell" size="medium">
              <el-form-item>
                <el-select
                  v-model="stockSell.info"
                  filterable
                  remote
                  :remote-method="remoteMethod"
                  :loading="loading"
                  placeholder="代码/名称"
                  @change="changeInfo('sell', true)"
                  size="small"
                  class="full_width"
                >
                  <el-option
                    v-for="item in options"
                    :key="item.short"
                    :label="item.name + ' ' + item.short"
                    :value="item.short"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item style="margin-bottom: 0">
                <el-row>
                  <el-col :span="8">
                    <el-button
                      type="primary"
                      @click="changePrice('sell')"
                      v-if="changeSellType"
                      size="small"
                      class="full_width button_blue_color"
                      >市价</el-button
                    >
                    <el-button
                      type="primary"
                      @click="changePrice('sell')"
                      v-else
                      size="small"
                      class="full_width button_blue_color"
                      >限价</el-button
                    >
                  </el-col>
                  <el-col :span="16">
                    <el-input
                      v-if="changeSellType"
                      :disabled="true"
                      size="small"
                      class="full_width"
                      placeholder="市价卖出"
                    ></el-input>
                    <el-input
                      v-model="stockSell.limitPrice"
                      v-else
                      size="small"
                      class="full_width"
                      placeholder="卖出价"
                    ></el-input>
                  </el-col>
                </el-row>
                <p>
                  涨停价:<span class="text_blue_color">{{ stockSell.hardenPrice }}</span
                  >&nbsp;&nbsp;&nbsp;跌停价:<span class="text_blue_color">{{
                    stockSell.dropPrice
                  }}</span>
                </p>
              </el-form-item>
              <el-form-item style="margin-bottom: 0">
                <el-input
                  v-model="stockSell.number"
                  size="small"
                  placeholder="卖出量"
                ></el-input>
                <p>
                  可卖<span class="text_blue_color">{{
                    parseInt(stockSell.validNumber)
                  }}</span
                  >股
                </p>
              </el-form-item>
              <el-form-item>
                <el-row>
                  <el-col :span="6">
                    <el-button
                      class="full_width optionsSell"
                      size="small"
                      @click="position('sellFull')"
                      >全仓</el-button
                    >
                  </el-col>
                  <el-col :span="6">
                    <el-button
                      class="full_width optionsSell"
                      size="small"
                      @click="position('sellThreeFourths')"
                      >3/4</el-button
                    >
                  </el-col>
                  <el-col :span="6">
                    <el-button
                      class="full_width optionsSell"
                      size="small"
                      @click="position('sellTwoFourths')"
                      >1/2</el-button
                    >
                  </el-col>
                  <el-col :span="6">
                    <el-button
                      class="full_width optionsSell"
                      size="small"
                      @click="position('sellOneFourths')"
                      >1/4</el-button
                    >
                  </el-col>
                </el-row>
              </el-form-item>
              <el-form-item label-width="0">
                <el-button type="primary submit" class="button_blue_color" size="small" @click="sellStock"
                  >卖出</el-button
                >
              </el-form-item>
            </el-form>
          </el-col>
          <el-col :span="10">
            <el-card class="box-card" shadow="never">
              <el-row>
                <div
                  class="center box-market"
                  v-for="(item, index) in stockSell.sellArr" :key="index"
                >
                  <el-col :span="8">{{ item.id }}</el-col>
                  <el-col :span="8">{{ item.price }}</el-col>
                  <el-col :span="8">{{ item.number }}</el-col>
                </div>
              </el-row>
            </el-card>
            <el-card class="box-card" shadow="never" style="margin-top: 10px">
              <el-row>
                <p
                  class="center box-market"
                  v-for="(item, index) in stockSell.buyArr" :key="index"
                >
                  <el-col :span="8">{{ item.id }}</el-col>
                  <el-col :span="8">{{ item.price }}</el-col>
                  <el-col :span="8">{{ item.number }}</el-col>
                </p>
              </el-row>
            </el-card>
          </el-col>
          <el-col :span="24">
            <el-table
              :data="holdData"
              stripe
              height="240px"
              @row-click="sellHanddle"
              size="small"
              style="width: 100%"
            >
              <el-table-column label="名称/市值" align="center">
                <template slot-scope="scope">
                  <div v-if="scope.row.profitMarket.substr(0, 1) === '-'">
                    <p class="green">{{ scope.row.name }}</p>
                    <p class="green">{{ scope.row.market }}</p>
                  </div>
                  <div v-else>
                    <p class="text_red_color">{{ scope.row.name }}</p>
                    <p class="text_red_color">{{ scope.row.market }}</p>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="持仓/可用" align="center">
                <template slot-scope="scope">
                  <div v-if="scope.row.profitMarket.substr(0, 1) === '-'">
                    <p class="green">{{ scope.row.number }}</p>
                    <p class="green">{{ scope.row.sellable }}</p>
                  </div>
                  <div v-else>
                    <p class="text_red_color">{{ scope.row.number }}</p>
                    <p class="text_red_color">{{ scope.row.sellable }}</p>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="现价/均价" align="center">
                <template slot-scope="scope">
                  <div v-if="scope.row.priceRatio.substr(0, 1) === '-'">
                    <p class="green">{{ scope.row.newPrice }}</p>
                    <p class="green">{{ scope.row.price }}</p>
                  </div>
                  <div v-else>
                    <p class="text_red_color">{{ scope.row.newPrice }}</p>
                    <p class="text_red_color">{{ scope.row.price }}</p>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="总盈亏" align="center">
                <template slot-scope="scope">
                  <div v-if="scope.row.profitMarket.substr(0, 1) === '-'">
                    <p class="green">{{ scope.row.profitMarket }}</p>
                    <p class="green">{{ scope.row.priceRatio }}%</p>
                  </div>
                  <div v-else>
                    <p class="text_red_color">{{ scope.row.profitMarket }}</p>
                    <p class="text_red_color">{{ scope.row.priceRatio }}%</p>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
      </el-tab-pane>
      <el-tab-pane label="撤单" name="canceStock">
        <el-table
          :data="cancelData"
          height="560px"
          size="small"
          stripe
          style="width: 100%"
        >
          <el-table-column label="股票/时间" align="center">
            <template slot-scope="scope">
              <p>{{ scope.row.name }}</p>
              <p>{{ scope.row.accurate }}</p>
            </template>
          </el-table-column>
          <el-table-column label="委托价" align="center">
            <template slot-scope="scope">
              <p>{{ scope.row.deal }}</p>
            </template>
          </el-table-column>
          <el-table-column label="委托/成交" align="center">
            <template slot-scope="scope">
              <p>{{ scope.row.number }}</p>
              <p>{{ scope.row.finish }}</p>
            </template>
          </el-table-column>
          <el-table-column label="业务/状态" align="center">
            <template slot-scope="scope">
              <p>{{ scope.row.type }}</p>
              <p>{{ scope.row.status }}</p>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="danger"
                class="button_red_color"
                @click="handleCance(scope.row)"
                >撤单</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="持仓" name="holdStock">
        <el-row style="padding-top: 10px">
        <el-col span="24"><span>当前总资产(元)</span></el-col>
      </el-row>
      <el-row>
        <el-col span="24" style="font-size: 13px"><span>{{ total }}</span></el-col>
      </el-row>
      
      <el-row style="padding-top: 10px;" class="bottom_style">
        <el-col span="8" class="columnDesign">
          <el-row class="topValue" style="font-size: 14px"
            ><span>持仓市值(元)</span>
          </el-row>
          <el-row style="font-size: 13px" class="topValue"
            ><span style="color: #000000">{{ market }}</span>
          </el-row>
        </el-col>
        <el-col span="8" class="columnDesign">
          <el-row class="topValue" style="font-size: 14px"
            ><span>持仓比例</span>
          </el-row>
          <el-row style="font-size: 13px" class="topValue"
            ><span style="color: #000000">{{depot_ratio}}</span>
          </el-row>
        </el-col>
        <el-col span="8" class="columnDesign" style="background: none">
          <el-row class="topValue" style="font-size: 14px"
            ><span>可用额度(元)</span>
          </el-row>
          <el-row style="font-size: 13px" class="topValue"
            ><span style="color: #000000">{{UserAvailable}}</span>
          </el-row>
        </el-col>
      </el-row>
      <el-row style="padding-top: 10px">
        <el-col span="24"><span>当前盈亏(元)</span></el-col>
      </el-row>
      <el-row>
        <el-col span="24" style="font-size: 13px"
          ><span v-bind:class="[profit_loss >= 0 ? 'red' : 'green']">{{
            profit_loss
          }}</span
          ><span
            v-bind:class="[ratioValue >= 0 ? 'red' : 'green']"
            style="padding-left: 10px"
            >{{ ratio }}</span
          ></el-col
        >
      </el-row>
      <el-row style="text-align: center; padding-top: 20px">
        <el-col span="24">
          <img src="../assets/img/capital_meter.png" />
        </el-col>
      </el-row>
      <el-row
        style="
          text-align: center;
          border-bottom: 1px solid #dcdee0;
          padding-bottom: 10px;
        "
      >
      <el-col span="12"
          ><span style="color: #D02E27">亏损警戒线 (亏损比)<br>{{ warning }} ({{ warning_line_ratio }})</span></el-col
        >
        <el-col span="12"
          ><span style="color: #3f7a21">亏损平仓线 （亏损比）<br>{{ close }} ({{ close_line_ratio }})</span></el-col
        >
      </el-row>
      <el-row style="padding-top: 10px;padding-bottom:10px;" class="bottom_style">
        <el-col span="8" class="columnDesign">
          <el-row class="topValue" style="font-size: 14px"
            ><span>总配资资金</span>
          </el-row>
          <el-row style="font-size: 13px" class="topValue"
            ><span style="color: #000000">{{ capital_total }}</span>
          </el-row>
        </el-col>
        <el-col span="8" class="columnDesign">
          <el-row class="topValue" style="font-size: 14px"
            ><span>申请额度</span>
          </el-row>
          <el-row style="font-size: 13px" class="topValue"
            ><span style="color: #000000">{{ apply_quota }}</span>
          </el-row>
        </el-col>
        <el-col span="8" class="columnDesign" style="background: none">
          <el-row class="topValue" style="font-size: 14px"
            ><span>风险保证金</span>
          </el-row>
          <el-row style="font-size: 13px" class="topValue"
            ><span style="color: #000000">{{ bond }}</span>
          </el-row>
        </el-col>
      </el-row>
      <el-row style="text-align: center; padding-top: 20px">
        <el-col :span="6" style="color: #D02E27;cursor: pointer;">
                    <span
                      class="text-border"
                      @click="showAdd(operateData)"
                      >追加配资</span
                    >
                  </el-col>
        <el-col :span="6" style="color: #D02E27;cursor: pointer;">
                    <span
                     class="text-border"
                      @click="showBondAdd(operateData)"
                      >追加保证金</span
                    >
                  </el-col>
        <el-col :span="6" style="color: #D02E27;cursor: pointer;">
                    <span
                      class="text-border"
                      @click="showSettlement(operateData)"
                      >申请结算</span
                    >
                  </el-col>
                  <el-col :span="6" style="color: #D02E27;cursor: pointer;">
                    <span
                      class="text-border"
                      @click="getCapitalDataAll(operateData,'all')"
                      >资金明细</span
                    >
                  </el-col>
      </el-row>
      <el-row class="before_table_style"></el-row>
        <el-table
          height="560px"
          size="small"
          :data="holdData"
          stripe
          style="width: 100%"
        >
          <el-table-column type="expand">
            <template slot-scope="props">
              <el-form label-position="left" inline class="demo-table-expand">
                <el-row>
                  <el-col :span="8" class="center">
                    <el-button
                      type="primary"
                      class="button_blue_color"
                      size="small"
                      @click="holdBuy(props.row.short)"
                      >买入</el-button
                    >
                  </el-col>
                  <el-col :span="8" class="center">
                    <el-button
                      type="primary"
                      size="small"
                      class="button_blue_color"
                      @click="holdSell(props.row.short)"
                      >卖出</el-button
                    >
                  </el-col>
                  <el-col :span="8" class="center">
                    <el-button
                      type="primary"
                      size="small"
                      class="button_blue_color"
                      @click="marketGo(props.row.short)"
                      >行情</el-button
                    >
                  </el-col>
                </el-row>
              </el-form>
            </template>
          </el-table-column>
          <el-table-column label="名称/市值">
            <template slot-scope="scope">
              <div v-if="scope.row.profitMarket.substr(0, 1) === '-'">
                <p class="green">{{ scope.row.name }}</p>
                <p class="green">{{ scope.row.market }}</p>
              </div>
              <div v-else>
                <p class="text_red_color">{{ scope.row.name }}</p>
                <p class="text_red_color">{{ scope.row.market }}</p>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="持仓/可用">
            <template slot-scope="scope">
              <div v-if="scope.row.profitMarket.substr(0, 1) === '-'">
                <p class="green">{{ scope.row.number }}</p>
                <p class="green">{{ scope.row.sellable }}</p>
              </div>
              <div v-else>
                <p class="text_red_color">{{ scope.row.number }}</p>
                <p class="text_red_color">{{ scope.row.sellable }}</p>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="现价/均价">
            <template slot-scope="scope">
              <div v-if="scope.row.profitMarket.substr(0, 1) === '-'">
                <p class="green">{{ scope.row.newPrice }}</p>
                <p class="green">{{ scope.row.price }}</p>
              </div>
              <div v-else>
                <p class="text_red_color">{{ scope.row.newPrice }}</p>
                <p class="text_red_color">{{ scope.row.price }}</p>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="总盈亏">
            <template slot-scope="scope">
              <div v-if="scope.row.profitMarket.substr(0, 1) === '-'">
                <p class="green">{{ scope.row.profitMarket }}</p>
                <p class="green">{{ scope.row.priceRatio }}%</p>
              </div>
              <div v-else>
                <p class="text_red_color">{{ scope.row.profitMarket }}</p>
                <p class="text_red_color">{{ scope.row.priceRatio }}%</p>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="查询">
        <el-tabs stretch>
          <el-tab-pane label="委托查询">
            <el-table
              size="small"
              height="505px"
              :data="entrustData"
              stripe
              style="width: 100%"
            >
              <el-table-column label="日期/时间" align="center">
                <template slot-scope="scope">
                  <p>{{ scope.row.time }}</p>
                  <p>{{ scope.row.accurate }}&nbsp;</p>
                </template>
              </el-table-column>
              <el-table-column label="名称/代码" align="center">
                <template slot-scope="scope">
                  <p>{{ scope.row.name }}</p>
                  <p>{{ scope.row.code }}</p>
                </template>
              </el-table-column>
              <el-table-column label="买卖/状态" align="center">
                <template slot-scope="scope">
                  <p>{{ scope.row.type }}</p>
                  <p>{{ scope.row.status }}&nbsp;</p>
                </template>
              </el-table-column>
              <el-table-column label="委托/成交价" align="center">
                <template slot-scope="scope">
                  <p>{{ scope.row.deal }}&nbsp;</p>
                  <p>{{ scope.row.price }}&nbsp;</p>
                </template>
              </el-table-column>
              <el-table-column label="委托/成交量" align="center">
                <template slot-scope="scope">
                  <p>{{ scope.row.number }}&nbsp;</p>
                  <p>{{ scope.row.finish }}&nbsp;</p>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="成交记录">
            <el-table
              size="small"
              height="505px"
              :data="dealData"
              stripe
              style="width: 100%"
            >
              <el-table-column type="expand">
                <template slot-scope="props">
                  <el-form label-position="right" size="mini">
                    <el-form-item label="日期时间">
                      <p class="right">
                        {{ props.row.time }} {{ props.row.accurate }}
                      </p>
                    </el-form-item>
                    <el-form-item label="业务名称">
                      <p class="right">{{ props.row.type }}</p>
                    </el-form-item>
                    <el-form-item label="股票代码">
                      <p class="right">
                        {{ props.row.name }} {{ props.row.code }}
                      </p>
                    </el-form-item>
                    <el-form-item label="成交数量">
                      <p class="right">{{ props.row.number }}</p>
                    </el-form-item>
                    <el-form-item label="成交价格">
                      <p class="right">{{ props.row.price }}</p>
                    </el-form-item>
                    <el-form-item label="成交金额">
                      <p class="right">{{ props.row.total }}</p>
                    </el-form-item>
                    <el-form-item label="券商佣金">
                      <p class="right">{{ props.row.commission }}</p>
                    </el-form-item>
                    <el-form-item label="过户费">
                      <p class="right">{{ props.row.change }}</p>
                    </el-form-item>
                    <el-form-item label="印花税">
                      <p class="right">{{ props.row.stamp }}</p>
                    </el-form-item>
                    <el-form-item label="产品处理费">
                      <p class="right">{{ props.row.extra_fee1 }}</p>
                    </el-form-item>
                    <el-form-item label="结算费用">
                      <p class="right">{{ props.row.extra_fee2 }}</p>
                    </el-form-item>
                    <el-form-item label="平台费用">
                      <p class="right">{{ props.row.extra_fee3 }}</p>
                    </el-form-item>
                    <el-form-item label="总金额">
                      <p class="right">{{ props.row.totalplus }}</p>
                    </el-form-item>
                  </el-form>
                </template>
              </el-table-column>
              <el-table-column label="日期/时间" align="center">
                <template slot-scope="scope">
                  <p>{{ scope.row.time }}</p>
                  <p>{{ scope.row.accurate }}</p>
                </template>
              </el-table-column>
              <el-table-column label="名称/代码" align="center">
                <template slot-scope="scope">
                  <p>{{ scope.row.name }}</p>
                  <p>{{ scope.row.code }}</p>
                </template>
              </el-table-column>
              <el-table-column label="买卖/数量" align="center">
                <template slot-scope="scope">
                  <p>{{ scope.row.type }}</p>
                  <p>{{ scope.row.number }}</p>
                </template>
              </el-table-column>
              <el-table-column label="单价/总价" align="center">
                <template slot-scope="scope">
                  <p>{{ scope.row.price }}</p>
                  <p>{{ scope.row.total }}</p>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="系统平仓">
            <el-table
              size="small"
              height="505px"
              :data="unwindData"
              stripe
              style="width: 100%"
            >
              <el-table-column type="expand">
                <template slot-scope="props">
                  <el-form label-position="right" size="mini">
                    <el-form-item label="日期时间">
                      <p class="right">
                        {{ props.row.time }} {{ props.row.accurate }}
                      </p>
                    </el-form-item>
                    <el-form-item label="业务名称">
                      <p class="right">{{ props.row.type }}</p>
                    </el-form-item>
                    <el-form-item label="股票代码">
                      <p class="right">
                        {{ props.row.name }} {{ props.row.code }}
                      </p>
                    </el-form-item>
                    <el-form-item label="成交数量">
                      <p class="right">{{ props.row.number }}</p>
                    </el-form-item>
                    <el-form-item label="成交价格">
                      <p class="right">{{ props.row.price }}</p>
                    </el-form-item>
                    <el-form-item label="券商佣金">
                      <p class="right">{{ props.row.commission }}</p>
                    </el-form-item>
                    <el-form-item label="过户费">
                      <p class="right">{{ props.row.change }}</p>
                    </el-form-item>
                    <el-form-item label="印花税">
                      <p class="right">{{ props.row.stamp }}</p>
                    </el-form-item>
                    <el-form-item label="总金额">
                      <p class="right">{{ props.row.total }}</p>
                    </el-form-item>
                  </el-form>
                </template>
              </el-table-column>
              <el-table-column label="日期/时间" align="center">
                <template slot-scope="scope">
                  <p>{{ scope.row.time }}</p>
                  <p>{{ scope.row.accurate }}</p>
                </template>
              </el-table-column>
              <el-table-column label="名称/代码" align="center">
                <template slot-scope="scope">
                  <p>{{ scope.row.name }}</p>
                  <p>{{ scope.row.code }}</p>
                </template>
              </el-table-column>
              <el-table-column label="买卖/数量" align="center">
                <template slot-scope="scope">
                  <p>{{ scope.row.type }}</p>
                  <p>{{ scope.row.number }}</p>
                </template>
              </el-table-column>
              <el-table-column label="单价/总价" align="center">
                <template slot-scope="scope">
                  <p>{{ scope.row.price }}</p>
                  <p>{{ scope.row.total }}</p>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="对账单">
            <el-table
              height="505px"
              size="small"
              :data="capitalData"
              stripe
              style="width: 100%"
            >
              <el-table-column label="日期" align="center">
                <template slot-scope="scope">
                  <p>{{ scope.row.time }}</p>
                  <p>{{ scope.row.accurate }}</p>
                </template>
              </el-table-column>
              <el-table-column label="名称/类型" align="center">
                <template slot-scope="scope">
                  <p>{{ scope.row.name }}</p>
                  <p>{{ scope.row.type }}</p>
                </template>
              </el-table-column>
              <el-table-column label="金额/余额" align="center">
                <template slot-scope="scope">
                  <p>{{ scope.row.number }}</p>
                  <p>{{ scope.row.balance }}</p>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </el-tab-pane>
    </el-tabs>
    <!-- ============================== Start change channel popup ========================== -->
    <el-dialog
      :visible.sync="showTradeChannelPopup"
      width="40%"
      center
      custom-class="tradingChannelPop"
    >
      <div v-html="trade_rules_content_top"></div>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          @click="agreeTradeRules()"
          style="background: #ff0000; border-color: #ff0000; width: 200px"
          >我已经明白
        </el-button>
        <div
          v-html="trade_rules_content_bottom"
          style="padding-top: 10px"
        ></div>
      </span>
    </el-dialog>
    <!-- ============================== end change channel popup ========================== -->
    <div v-loading.fullscreen.lock="fullscreenLoading"></div>
  </div>
</template>

<script>
import $ from "jquery";
import eventBus from "../assets/js/eventBus";

export default {
  name: "stocktrading",
  data() {
    return {
      capitalState: false,
      capitalData: [],
      cashCapitalInfo:"0.00",
        afterCashCapitalInfo:"",
        cashBondInfo:"0.00",
        balance: "0.00",
        afterCashBondInfo:"",
        increase_bond_capital:"",
        increase_bond:"",
        warning_ratio:"0.00",
        close_ratio:"0.00",
        multiple:0,
        number:0,
        balanceAfter:"0.00",
        warning_line_ratio_increase_info:"0.00",
        close_line_ratio_increase_info:"0.00",
        warningIncreaseInfo: "0.00",
        closeIncreaseInfo: "0.00",
        warning_line_ratio_increase_info_after:"0.00",
        close_line_ratio_increase_info_after:"0.00",
        warningIncreaseInfoAfter: "0.00",
        closeIncreaseInfoAfter: "0.00",
        warning_line_ratio_increase_bond_info:"0.00",
        close_line_ratio_increase_bond_info:"0.00",
        warningIncreaseBondInfo: "0.00",
        closeIncreaseBondInfo: "0.00",
        warning_line_ratio_increase_bond_info_after:"0.00",
        close_line_ratio_increase_bond_info_after:"0.00",
        activeName: '1',
        cid: '',
      tabsName: "buyStock",
      //股票买入
      stockBuy: {
        info: "",
        marketPrice: "", //市价
        limitPrice: "", //现价
        hardenPrice: 0, //涨停
        dropPrice: 0, //跌停
        number: "",
        buyArr: [
          {
            id: "买1",
            price: "- -",
            number: "- -",
          },
          {
            id: "买2",
            price: "- -",
            number: "- -",
          },
          {
            id: "买3",
            price: "- -",
            number: "- -",
          },
          {
            id: "买4",
            price: "- -",
            number: "- -",
          },
          {
            id: "买5",
            price: "- -",
            number: "- -",
          },
        ], //五档行情
        sellArr: [
          {
            id: "卖5",
            price: "- -",
            number: "- -",
          },
          {
            id: "卖4",
            price: "- -",
            number: "- -",
          },
          {
            id: "卖3",
            price: "- -",
            number: "- -",
          },
          {
            id: "卖2",
            price: "- -",
            number: "- -",
          },
          {
            id: "卖1",
            price: "- -",
            number: "- -",
          },
        ],
      },
      //股票卖出
      stockSell: {
        info: "",
        marketPrice: "", //市价
        limitPrice: "", //现价
        hardenPrice: 0, //涨停
        dropPrice: 0, //跌停
        number: "",
        buyArr: [
          {
            id: "买1",
            price: "- -",
            number: "- -",
          },
          {
            id: "买2",
            price: "- -",
            number: "- -",
          },
          {
            id: "买3",
            price: "- -",
            number: "- -",
          },
          {
            id: "买4",
            price: "- -",
            number: "- -",
          },
          {
            id: "买5",
            price: "- -",
            number: "- -",
          },
        ], //五档行情
        sellArr: [
          {
            id: "卖5",
            price: "- -",
            number: "- -",
          },
          {
            id: "卖4",
            price: "- -",
            number: "- -",
          },
          {
            id: "卖3",
            price: "- -",
            number: "- -",
          },
          {
            id: "卖2",
            price: "- -",
            number: "- -",
          },
          {
            id: "卖1",
            price: "- -",
            number: "- -",
          },
        ],
        validNumber: 0,
      },
      //撤单
      cancelData: [],
      //持仓
      holdData: [],
      //委托
      entrustData: [],
      //成交
      dealData: [],
      //账户信息
      operateOptions: [],
      //选中账户
      operateData: "",
      //流水资金
      capitalData: [],
      //修改市价限价
      changeBuyType: true,
      changeSellType: true,
      //用户可用余额
      UserAvailable: 0,
      warning_line_ratio:0,
      warning: 0,
      market: 0,
      depot_ratio: 0,
      profit_loss: 0,
      ratio: 0,
      ratioValue: 0,
      close: 0,
      close_line_ratio: 0,
      capital_total: 0,
      total: 0,
      apply_quota: 0,
      apply_quota: 0,
      //远程搜索
      loading: false,
      options: [],
      transmitCid: 0,
      unwindData: [],
      showTradeChannelPopup: false,
      trade_rules_content_top: "",
      trade_rules_content_bottom: "",
      fullscreenLoading: false
    };
  },
  computed: {
    selectedAccount() {
      return this.operateOptions.find(item => item.cid === this.operateData) || null;
    },
    
    //下拉框数据
    restaurants: function () {
      return this.$store.state.restaurants;
    },
    //买入市价计算
    buyMarketPrice: function () {
      let that = this;
      let marketPrice = parseInt(
        Number(that.UserAvailable) / Number(that.stockBuy.marketPrice)
      );
      if (isNaN(marketPrice)) {
        return 0;
      } else {
        return marketPrice;
      }
    },
    //买入限价计算
    buyLimitPrice: function () {
      let that = this;
      let limitPrice = parseInt(
        Number(that.UserAvailable) / Number(that.stockBuy.limitPrice)
      );
      if (isNaN(limitPrice)) {
        return 0;
      } else {
        return limitPrice;
      }
    },
  },
  methods: {
    refreshData(){
      this.fullscreenLoading = true;
      setTimeout(() => {
        if (this.$store.state.loginType) {
          this.changeOperate();
        }
          this.fullscreenLoading = false;
      }, 2000);
    },
    showSettlement(cid) {
        $(".show1Box").fadeIn(50);
        this.cid = cid;
      },
      //申请结算 - 隐藏
      hiddenSettlement() {
        $(".show1Box").fadeOut(50);
      },
      //申请结算 - 操作
      operationSettlement() {
        let that = this;
        $(".show1Box").fadeOut(50);
        that.$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "settlement",
            token: sessionStorage.getItem("token"),
            cid: that.cid
          }
        })
          .then(function (res) {
            if (res.data.code == 1) {
              that.$message({
                message: res.data.msg,
                type: "success",
                duration: 1000,
                onClose:function () {
                  that.$router.push({
                    path: "/myaccount/strategyhistory",
                  });
                }
              });
            } else if (res.data.code == 0 || res.data.code == -1) {
              that.$message.error(res.data.msg);
            }
          });
      },
      getCapitalDataAll(cid, information) {
        let that = this;
        that
          .$http({
            url: "/",
            method: "post",
            data: {
              'nozzle': 'capital_log',
              'token': window.sessionStorage.getItem('token'),
              'cid': cid
            }
          }).then(res => {
          if (res.data.code == 1) {
            let capitalData = res.data.data;
            switch (information) {
              case 'all':
                that.capitalState = true;
                that.capitalData = capitalData;
                break;
              case 'ensure':
                that.moneyState = true;
                let ensure = [];
                for (let i = 0, len = capitalData.length; i < len; i++) {
                  if (capitalData[i].typeState === 2 || capitalData[i].typeState === 14) {
                    ensure.push(capitalData[i]);
                  }
                }
                that.moneyData = ensure;
                break;
              case 'money':
                that.moneyState = true;
                let money = [];
                for (let i = 0, len = capitalData.length; i < len; i++) {
                  if (capitalData[i].typeState === 1 || capitalData[i].typeState === 2 || capitalData[i].typeState === 13 || capitalData[i].typeState === 14) {
                    money.push(capitalData[i]);
                  }
                }
                that.moneyData = money;
                break;

            }

          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$message.error(res.data.msg);
          }
        });
      },
      operationAdd() {
        let that = this;
        if (that.addMoney == "") {
          that.$message.error("请输入追加金额");
        } else {
          that.$http({
            url: "/",
            method: "post",
            data: {
              nozzle: "increase_capital_operate",
              token: sessionStorage.getItem("token"),
              cid: that.cid,
              number: that.addMoney
            }
          })
            .then(function (res) {
              if (res.data.code == 1) {
                that.$message({
                  message: res.data.msg,
                  type: "success",
                  duration: 1000
                });
                that.getOperate();
              } else if (res.data.code == 0 || res.data.code == -1) {
                that.$message.error(res.data.msg);
              }
            });
          $(".show3Box").fadeOut(50);
        }
      },
      showBondAdd(cid) {
        let that = this;
        that.addBondMoney = "";
        that.cid = cid;
        that.$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "increase_bond_info",
            token: sessionStorage.getItem("token"),
            cid: cid
          }
        })
          .then(function (res) {
            if (res.data.code == 1) {
              that.balance = res.data.data.total;
              that.minBondAdd = res.data.data.min_bond;
              that.warningIncreaseBondInfo = res.data.data.warning;
              that.closeIncreaseBondInfo = res.data.data.close;
              that.warning_line_ratio_increase_bond_info = res.data.data.warning_line_ratio;
              that.close_line_ratio_increase_bond_info = res.data.data.close_line_ratio;
              that.multiple = res.data.data.multiple;
              that.number = res.data.data.number;
              that.bond = res.data.data.bond;
              that.warning_ratio = res.data.data.warning_ratio;
              that.close_ratio = res.data.data.close_ratio;
              that.increase_bond = res.data.data.increase_bond;
              that.cashBondInfo = res.data.data.cash;

              that.afterCashBondInfo = that.cashBondInfo;
              that.balanceAfter = that.balance;
              that.warning_line_ratio_increase_bond_info_after = that.warning_line_ratio_increase_bond_info.replace(/[^0-9.-]/g, '');
              that.close_line_ratio_increase_bond_info_after = that.close_line_ratio_increase_bond_info.replace(/[^0-9.-]/g, '');

              $(".show4Box").fadeIn(50);
            } else if (res.data.code == 0 || res.data.code == -1) {
              that.$message.error(res.data.msg);
            }
          });
      },
      hiddenBondAdd() {
        $(".show4Box").fadeOut(50);
      },
      operationBondAdd() {
        let that = this;
        if (that.addBondMoney == "") {
          that.$message.error("请输入追加金额");
        } else {
          that.$http({
            url: "/",
            method: "post",
            data: {
              nozzle: "increase_bond_operate",
              token: sessionStorage.getItem("token"),
              cid: that.cid,
              number: that.addBondMoney
            }
          })
            .then(function (res) {
              if (res.data.code == 1) {
                that.$message({
                  message: res.data.msg,
                  type: "success",
                  duration: 1000
                });
                that.getOperate();
              } else if (res.data.code == 0 || res.data.code == -1) {
                that.$message.error(res.data.msg);
              }
            });
          $(".show4Box").fadeOut(50);
        }
      },
      showAdd(cid) {
        let that = this;
        that.addMoney = "";
        that.cid = cid;
        that.$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "increase_capital_info",
            token: sessionStorage.getItem("token"),
            cid: cid
          }
        })
          .then(function (res) {
            if (res.data.code == 1) {
              that.balance = res.data.data.total;
              that.minAdd = res.data.data.min_increase;
              that.warningIncreaseInfo = res.data.data.warning;
              that.closeIncreaseInfo = res.data.data.close;
              that.warning_line_ratio_increase_info = res.data.data.warning_line_ratio;
              that.close_line_ratio_increase_info = res.data.data.close_line_ratio;
              that.multiple = res.data.data.multiple;
              that.number = res.data.data.number;
              that.bond = res.data.data.bond;
              that.warning_ratio = res.data.data.warning_ratio;
              that.close_ratio = res.data.data.close_ratio;
              that.increase_bond_capital = res.data.data.increase_bond;
              that.cashCapitalInfo = res.data.data.cash;

              that.afterCashCapitalInfo = that.cashCapitalInfo;
              that.balanceAfter = that.balance;
              that.warningIncreaseInfoAfter = that.warningIncreaseInfo;
              that.closeIncreaseInfoAfter = that.closeIncreaseInfo;
              that.warning_line_ratio_increase_info_after = that.warning_line_ratio_increase_info.replace(/[^0-9.-]/g, '');
              that.close_line_ratio_increase_info_after = that.close_line_ratio_increase_info.replace(/[^0-9.-]/g, '');

              $(".show3Box").fadeIn(50);
            } else if (res.data.code == 0 || res.data.code == -1) {
              that.$message.error(res.data.msg);
            }
          });
      },
      hiddenAdd() {
        $(".show3Box").fadeOut(50);
      },

    //获取持仓信息
    getHoldData() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "depot_stock",
            token: window.sessionStorage.getItem("token"),
            cid: that.operateData,
          },
        })
        .then((res) => {
          if (res.data.code == 1) {
            var dataArr = res.data.data;
            var shortArr = [];
            if (dataArr.length != 0) {
              $.each(dataArr, function (index, item) {
                shortArr.push(item.short);
              });
              that.getNewPrice(shortArr, dataArr);
              clearInterval(window.timer1);
              window.timer1 = setInterval(function () {
                that.getNewPrice(shortArr, dataArr);
              }, 1000);
            } else {
              clearInterval(window.timer1);
              that.holdData = dataArr;
            }
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$message.error(res.data.msg);
          }
        });
    },
    openDetailed(event){
      let that = this;
      eventBus.$emit("state", event.trim());
      eventBus.$emit("symbol", event.trim());
        // this.$router.push({ name: 'Stockdetailed', query: {  symbol:that.stockSuggest.trim()+that.state.trim() }});
        this.$router.push({ name: 'Stockdetailed', query: { symbol:event.trim() }});
    },
    //请求当前价 计算 盈亏  盈亏比例
    getNewPrice(shortArr, dataArr) {
      let that = this;
      $.ajax({
        url: "https://qt.gtimg.cn/q=" + shortArr.toString(),
        type: "GET",
        dataType: "script",
        cache: true,
        success: function () {
          var i, elements;
          for (i = 0; i < shortArr.length; i++) {
            var elements = eval("v_" + shortArr[i]).split("~");
            dataArr[i]["newPrice"] = elements[3]; //当前价
            var newPrice = parseFloat(elements[3]); //当前价
            // dataArr[i]["newPrice"] = elements[9]; //当前价
            // var newPrice = parseFloat(elements[9]); //当前价
            var number = parseFloat(dataArr[i].number); //持有股数
            var costPrice = parseFloat(dataArr[i].price); //成本价
            var profitPrice = Number((newPrice - costPrice).toFixed(2)); //盈亏金额
            var priceRatio = ((newPrice - costPrice) / costPrice) * 100; //盈亏比例
            var market = (newPrice * number).toFixed(2); //当前市值
            let profitMarket = (
              newPrice * number -
              dataArr[i].costtotal
            ).toFixed(2); //浮动亏损
            priceRatio = priceRatio.toFixed(2);
            dataArr[i]["profitPrice"] = profitPrice;
            dataArr[i]["priceRatio"] = priceRatio;
            dataArr[i]["market"] = market;
            dataArr[i]["profitMarket"] = profitMarket;
          }
          that.holdData = dataArr;
        },
      });
    },
    //获取全部委托信息
    getEntrustData() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "entrust_log",
            token: window.sessionStorage.getItem("token"),
            cid: that.operateData,
          },
        })
        .then((res) => {
          if (res.data.code == 1) {
            let entrustData = res.data.data;
            for (let i = 0, len = entrustData.length; i < len; i++) {
              if (Number(entrustData[i].deal) === 0) {
                entrustData[i].deal = "--";
              }
              if (Number(entrustData[i].price) === 0) {
                entrustData[i].price = "--";
              }
            }
            that.entrustData = entrustData;
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$message.error(res.data.msg);
          }
        });
    },
    //获取全部成交订单
    getDealData() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "deal_log",
            token: window.sessionStorage.getItem("token"),
            cid: that.operateData,
          },
        })
        .then((res) => {
          if (res.data.code == 1) {
            let dealData = res.data.data;
            let unwindData = [];
            for (let i = 0, len = dealData.length; i < len; i++) {
              if (dealData[i].depot_mold === 1) {
                unwindData.push(dealData[i]);
              }
            }
            that.unwindData = unwindData;
            that.dealData = dealData;
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$message.error(res.data.msg);
          }
        });
    },
    //获取全部撤单
    getCancelData() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "cancel_order",
            token: window.sessionStorage.getItem("token"),
            cid: that.operateData,
          },
        })
        .then((res) => {
          if (res.data.code == 1) {
            that.cancelData = res.data.data;
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$message.error(res.data.msg);
          }
        });
    },
    //获取账户号
    getOperate() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "current_operate",
            token: window.sessionStorage.getItem("token"),
          },
        })
        .then((res) => {
          if (res.data.code == 1) {
            that.operateOptions = res.data.data;
            if (that.$route.query.cid) {
              that.operateData = parseInt(that.$route.query.cid);
            } else {
              if (that.operateData === "") {
                that.operateData = that.operateOptions[0].cid;
              }
            }

            that.changeOperate();
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$message.error(res.data.msg);
          }
        });
    },
    //获取用户子账户可用余额
    getUserAvailable() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "current_detailed",
            token: window.sessionStorage.getItem("token"),
            cid: that.operateData,
          },
        })
        .then((res) => {
          if (res.data.code == 1) {
            that.UserAvailable = res.data.data.available;
            that.market = res.data.data.market;
            that.depot_ratio = res.data.data.depot_ratio;
            that.profit_loss = res.data.data.profit_loss;
            that.ratio = res.data.data.ratio;
            that.ratioValue = res.data.data.ratio.replace(/['%]+/g, "");
            that.warning_line_ratio = res.data.data.warning_line_ratio;
            that.warning = res.data.data.warning;
            that.close = res.data.data.close;
            that.close_line_ratio = res.data.data.close_line_ratio;
            that.capital_total = res.data.data.capital_total;
            that.total = res.data.data.total;
            that.apply_quota = res.data.data.apply_quota;
            that.bond = res.data.data.bond;
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$message.error(res.data.msg);
          }
        });
    },
    //更改账户
    changeOperate(cid) {
      let that = this;
      that.$route.query.cid = that.operateData;
      that.getHoldData();
      that.getEntrustData();
      that.getDealData();
      that.getCancelData();
      that.getCapitalData();
      that.getUserAvailable();
    },
    //获取资金流水
    getCapitalData() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "capital_log",
            token: window.sessionStorage.getItem("token"),
            cid: that.operateData,
          },
        })
        .then((res) => {
          if (res.data.code == 1) {
            let capitalData = res.data.data;
            for (let i = 0, len = capitalData.length; i < len; i++) {
              capitalData[i].accurate = that
                .$moment(capitalData[i].time)
                .format("HH:mm:ss");
              capitalData[i].time = that
                .$moment(capitalData[i].time)
                .format("YYYY.MM.DD");
            }
            that.capitalData = capitalData;
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$message.error(res.data.msg);
          }
        });
    },
    //修改市价限价
    changePrice(deal) {
      let that = this;
      if (deal === "buy") {
        that.changeBuyType
          ? (that.changeBuyType = false)
          : (that.changeBuyType = true);
        that.changeBuyType
          ? ""
          : (that.stockBuy.limitPrice = that.stockBuy.marketPrice);
      } else if (deal === "sell") {
        that.changeSellType
          ? (that.changeSellType = false)
          : (that.changeSellType = true);
        that.changeSellType
          ? ""
          : (that.stockSell.limitPrice = that.stockSell.marketPrice);
      }
    },
    //修改股票信息
    //pass optional paramater changeLimitPrice to change the limit price value in the input
    changeInfo(deal, changeLimitPrice = false) {
      let that = this;
      if (deal === "buy") {
        $.ajax({
          url: "https://qt.gtimg.cn/q=" + that.stockBuy.info.toString(),
          type: "GET",
          dataType: "script",
          cache: true,
          success: function () {
            let elements = eval("v_" + that.stockBuy.info).split("~");
            $.each(that.stockBuy.buyArr, function (index, item) {
              item.price = elements[index * 2 + 9];
              item.number = elements[index * 2 + 10];
            });
            $.each(that.stockBuy.sellArr, function (index, item) {
              item.price = elements[27 - index * 2];
              item.number = elements[28 - index * 2];
            });
            that.stockBuy.marketPrice = elements[3];//that.stockBuy.sellArr[4].price;
            if (changeLimitPrice)
              that.stockBuy.limitPrice = that.stockBuy.sellArr[4].price;
            // that.stockBuy.limitPrice =  that.stockBuy.sellArr[4].price;
            that.stockBuy.hardenPrice = elements[47];
            that.stockBuy.dropPrice = elements[48];
          },
        });
        clearInterval(window.timer3);
        window.timer3 = setInterval(function () {
          that.changeInfo("buy");
        }, 1000);
      } else if (deal === "sell") {
        $.ajax({
          url: "https://qt.gtimg.cn/q=" + that.stockSell.info.toString(),
          type: "GET",
          dataType: "script",
          cache: true,
          success: function () {
            let elements = eval("v_" + that.stockSell.info).split("~");
            $.each(that.stockSell.buyArr, function (index, item) {
              item.price = elements[index * 2 + 9];
              item.number = elements[index * 2 + 10];
            });
            $.each(that.stockSell.sellArr, function (index, item) {
              item.price = elements[27 - index * 2];
              item.number = elements[28 - index * 2];
            });
            that.stockSell.marketPrice = elements[3];//that.stockSell.buyArr[0].price;
            if (changeLimitPrice)
              that.stockSell.limitPrice = that.stockSell.buyArr[0].price;
            // that.stockSell.limitPrice = that.stockSell.buyArr[0].price;
            that.stockSell.hardenPrice = elements[47];
            that.stockSell.dropPrice = elements[48];
          },
        });
        let sellable = 0;
        for (let i = 0, len = that.holdData.length; i < len; i++) {
          if (that.holdData[i].short.trim() === that.stockSell.info.trim()) {
            sellable = that.holdData[i].sellable;
          }
        }
        that.stockSell.validNumber = sellable;
        clearInterval(window.timer2);
        window.timer2 = setInterval(function () {
          that.changeInfo("sell");
        }, 1000);
      }
    },
    //快速选仓
    position(storehouse) {
      let that = this;
      switch (storehouse) {
        case "buyFull":
          if (that.changeBuyType) {
            that.stockBuy.number =
              parseInt(
                parseInt(
                  Number(that.UserAvailable) / Number(that.stockBuy.marketPrice)
                ) / 100
              ) * 100;
          } else {
            that.stockBuy.number =
              parseInt(
                parseInt(
                  Number(that.UserAvailable) / Number(that.stockBuy.limitPrice)
                ) / 100
              ) * 100;
          }
          break;
        case "buyThreeFourths":
          if (that.changeBuyType) {
            that.stockBuy.number =
              parseInt(
                parseInt(
                  parseInt(
                    Number(that.UserAvailable) /
                      Number(that.stockBuy.marketPrice)
                  ) * 0.75
                ) / 100
              ) * 100;
          } else {
            that.stockBuy.number =
              parseInt(
                parseInt(
                  parseInt(
                    Number(that.UserAvailable) /
                      Number(that.stockBuy.limitPrice)
                  ) * 0.75
                ) / 100
              ) * 100;
          }
          break;
        case "buyTwoFourths":
          if (that.changeBuyType) {
            that.stockBuy.number =
              parseInt(
                parseInt(
                  parseInt(
                    Number(that.UserAvailable) /
                      Number(that.stockBuy.marketPrice)
                  ) * 0.5
                ) / 100
              ) * 100;
          } else {
            that.stockBuy.number =
              parseInt(
                parseInt(
                  parseInt(
                    Number(that.UserAvailable) /
                      Number(that.stockBuy.limitPrice)
                  ) * 0.5
                ) / 100
              ) * 100;
          }
          break;
        case "buyOneFourths":
          if (that.changeBuyType) {
            that.stockBuy.number =
              parseInt(
                parseInt(
                  parseInt(
                    Number(that.UserAvailable) /
                      Number(that.stockBuy.marketPrice)
                  ) * 0.25
                ) / 100
              ) * 100;
          } else {
            that.stockBuy.number =
              parseInt(
                parseInt(
                  parseInt(
                    Number(that.UserAvailable) /
                      Number(that.stockBuy.limitPrice)
                  ) * 0.25
                ) / 100
              ) * 100;
          }
          break;
        case "sellFull":
          that.stockSell.number =
            parseInt(parseInt(that.stockSell.validNumber) / 100) * 100;
          break;
        case "sellThreeFourths":
          that.stockSell.number =
            parseInt(parseInt(that.stockSell.validNumber * 0.75) / 100) * 100;
          break;
        case "sellTwoFourths":
          that.stockSell.number =
            parseInt(parseInt(that.stockSell.validNumber * 0.5) / 100) * 100;
          break;
        case "sellOneFourths":
          that.stockSell.number =
            parseInt(parseInt(that.stockSell.validNumber * 0.25) / 100) * 100;
          break;
      }
    },
    remoteMethod(query) {
      let that = this;
      if (query !== "") {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.options = that.restaurants.filter((item) => {
            return (
              item.name.toLowerCase().indexOf(query.toLowerCase()) > -1 ||
              item.short.toLowerCase().indexOf(query.toLowerCase()) > -1 ||
              item.pinyin.toLowerCase().indexOf(query.toLowerCase()) > -1
            );
          });
        }, 200);
      } else {
        this.options = [];
      }
    },
    //购买股票
    buyStock() {
      let token = window.sessionStorage.getItem("token");
      let that = this;
      let buyPrice = 0;
      let mold = 0;
      if (that.changeBuyType) {
        mold = 2;
        buyPrice = Number(that.stockBuy.marketPrice);
      } else {
        mold = 1;
        buyPrice = Number(that.stockBuy.limitPrice);
      }
      let buyCode = that.stockBuy.info.replace(/[^0-9]/gi, "");
      let buyNumber = parseInt(that.stockBuy.number);
      if (token === null) {
        this.$message.error({
          message: "您还未登录,请先去登录后在操作购买",
          onClose: function () {
            that.$router.push({ path: "/login" });
          },
        });
      } else if (buyCode === "" || isNaN(buyCode)) {
        this.$message.error({
          message: "您未选择股票",
        });
      } else if (buyNumber === "" || isNaN(buyNumber)) {
        this.$message.error({
          message: "您未选择购买数量",
        });
      } else {
        that
          .$confirm(
            // "以" +
            // buyPrice +
            // "元的价格买入" +
            // buyNumber +
            // "股, 是否继续?",
            // "买入股票",
            "您是否确定买入该股票?",
            "确认交易",
            {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            }
          )
          .then(() => {
            that
              .$http({
                url: "/",
                method: "post",
                data: {
                  nozzle: "buy_stock",
                  token: sessionStorage.getItem("token"),
                  cid: that.operateData,
                  code: buyCode,
                  number: buyNumber,
                  price: buyPrice,
                  mold: mold,
                },
              })
              .then(function (res) {
                if (res.data.code == 1) {
                  that.$message({
                    message: res.data.msg,
                    type: "success",
                    duration: 1000,
                    onClose: function () {
                      that.getOperate();
                      that.stockBuy.number = "";
                    },
                  });
                } else if (res.data.code == 2) {
                  that.getTradeChannel();
                } else if (res.data.code == 0 || res.data.code == -1) {
                  that.$message.error(res.data.msg);
                }
              });
          })
          .catch(() => {
            that.$message({
              type: "info",
              message: "已取消买入",
            });
          });
      }
    },
    //卖出股票
    sellStock() {
      let that = this;
      let holdFlag = false;
      for (let i = 0, len = that.holdData.length; i < len; i++) {
        if (that.holdData[i].short.trim() === that.stockSell.info.trim()) {
          holdFlag = true;
        }
      }

      let token = window.sessionStorage.getItem("token");

      let sellPrice = 0;

      let mold = 0;
      if (that.changeSellType) {
        mold = 2;
        sellPrice = Number(that.stockSell.marketPrice);
      } else {
        mold = 1;
        sellPrice = Number(that.stockSell.limitPrice);
      }
      let sellCode = that.stockSell.info.replace(/[^0-9]/gi, "");
      let sellNumber = parseInt(that.stockSell.number);

      if (token === null) {
        this.$message.error({
          message: "您还未登录,请先去登录后在操作卖出",
          onClose: function () {
            that.$router.push({ path: "/login" });
          },
        });
      } else if (!holdFlag) {
        that.stockSell.validNumber = 0;
        this.$message.error("还未购买此股票,请进入购买页面购买此股票");
      } else if (sellCode === "" || isNaN(sellCode)) {
        this.$message.error({
          message: "您未选择股票",
        });
      } else if (sellNumber === "" || isNaN(sellNumber)) {
        this.$message.error({
          message: "您未选择卖出数量",
        });
      } else {
        that
          .$confirm(
            // "以" +
            // sellPrice +
            // "的价格卖出" +
            // sellNumber +
            // "股, 是否继续?",
            // "卖出股票",
            "您是否确认卖出该股票?",
            "确认交易",
            {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            }
          )
          .then(() => {
            that
              .$http({
                url: "/",
                method: "post",
                data: {
                  nozzle: "sell_stock",
                  token: sessionStorage.getItem("token"),
                  cid: that.operateData,
                  code: sellCode,
                  number: sellNumber,
                  price: sellPrice,
                  mold: mold,
                },
              })
              .then(function (res) {
                if (res.data.code == 1) {
                  that.$message({
                    message: res.data.msg,
                    type: "success",
                    duration: 1000,
                    onClose: function () {
                      that.getOperate();
                      that.stockSell.number = "";
                    },
                  });
                  /*that.$refs.child1.getStrategyInfo();
                      setTimeout(function() {
                        that.setNumber(that.maxNumber, that.ratio);
                        that.getHoldlist();
                        that.getInfo(that.short, 1);
                      }, 1000);*/
                } else if (res.data.code == 2) {
                  that.getTradeChannel();
                } else if (res.data.code == 0 || res.data.code == -1) {
                  that.$message.error(res.data.msg);
                }
              });
          })
          .catch(() => {
            that.$message({
              type: "info",
              message: "已取消卖出入",
            });
          });
      }
    },
    // ============= get the content of trade channel popup agreement ===========
    getTradeChannel() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "trade_popup",
            token: sessionStorage.getItem("token"),
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            that.trade_rules_content_top = res.data.data.content_top;
            that.trade_rules_content_bottom = res.data.data.content_bottom;
            that.showTradeChannelPopup = true;
          } else {
          }
        });
    },
    // ============================== Click agree the trade rules ========================
    agreeTradeRules() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "modify_trade_status",
            token: sessionStorage.getItem("token"),
            trade_channel_status: 1,
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            that.$message({
              message: res.data.msg,
              type: "success",
              duration: 1000,
            });
            that.showTradeChannelPopup = false;
            that.trade_channel_status = 0;
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$message.error(res.data.msg);
          }
        });
    },
    //点击表格触发赋值
    buyHanddle(row, event, column) {
      let that = this;
      that.stockBuy.info = row.short;
      that.changeInfo("buy", true);
      that.remoteMethod(row.short);
      this.$router.push({ name: 'Stockdetailed', query: { symbol:row.short }});
    },
    //点击卖出表格触发
    sellHanddle(row, event, column) {
      let that = this;
      that.stockSell.info = row.short;
      that.stockSell.validNumber = row.sellable;
      that.changeInfo("sell", true);
      that.remoteMethod(row.short);
      this.$router.push({ name: 'Stockdetailed', query: { symbol:row.short }});
    },
    //持仓页面进入买入页面
    holdBuy(short) {
      let that = this;
      that.stockBuy.info = short;
      that.changeInfo("buy", true);
      that.remoteMethod(short);
      this.tabsName = "buyStock";
    },
    //持仓页面进入卖出页面
    holdSell(short) {
      let that = this;
      that.stockSell.info = short;
      that.changeInfo("sell", true);
      that.remoteMethod(short);
      this.tabsName = "sellStock";
    },
    //持仓页面进入行情页面
    marketGo(short) {
      let that = this;
      that.$router.push("/stockdetailed?symbol=" + short);
    },
    //撤单
    handleCance(data) {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "cancel_entrust",
            token: sessionStorage.getItem("token"),
            cid: that.operateData,
            order: data.id,
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            that.$message({
              message: res.data.msg,
              type: "success",
              duration: 1000,
              onClose: function () {
                that.changeOperate();
              },
            });
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$message.error(res.data.msg);
          }
        });
    },
    //时间格式数据
    timeTypeData(value) {
      let temp = [];
      for (let i = 0, len = value.length; i < len; i++) {
        if (!temp.includes(value[i].time)) {
          temp.push(value[i].time);
        }
      }
      for (let i = 0, len = temp.length; i < len; i++) {
        temp[i] = { index: i + 1, time: temp[i], children: [] };
        for (let j = 0, len1 = value.length; j < len1; j++) {
          if (temp[i].time === value[j].time) {
            value[j].index = parseInt((i + 1).toString() + (j + 1).toString());
            temp[i].children.push(value[j]);
          }
        }
      }
      return temp;
    },
    handleClick(tab, event) {
      let that = this;
      if (tab.name == "canceStock") {
        that.changeOperate();
      }
       else if(tab.name =="sellStock" && that.stockSell.info){
        this.$router.push({ name: 'Stockdetailed', query: { symbol:that.stockSell.info, direction:0 }});
      }
       else if(tab.name =="buyStock" && that.stockBuy.info){
         this.$router.push({ name: 'Stockdetailed', query: { symbol:that.stockBuy.info, direction:0 }});
      }
    },
    showAdd(cid) {
        let that = this;
        that.addMoney = "";
        that.cid = cid;
        that.$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "increase_capital_info",
            token: sessionStorage.getItem("token"),
            cid: cid
          }
        })
          .then(function (res) {
            if (res.data.code == 1) {
              that.balance = res.data.data.total;
              that.minAdd = res.data.data.min_increase;
              that.warningIncreaseInfo = res.data.data.warning;
              that.closeIncreaseInfo = res.data.data.close;
              that.warning_line_ratio_increase_info = res.data.data.warning_line_ratio;
              that.close_line_ratio_increase_info = res.data.data.close_line_ratio;
              that.multiple = res.data.data.multiple;
              that.number = res.data.data.number;
              that.bond = res.data.data.bond;
              that.warning_ratio = res.data.data.warning_ratio;
              that.close_ratio = res.data.data.close_ratio;
              that.increase_bond_capital = res.data.data.increase_bond;
              that.cashCapitalInfo = res.data.data.cash;

              that.afterCashCapitalInfo = that.cashCapitalInfo;
              that.balanceAfter = that.balance;
              that.warningIncreaseInfoAfter = that.warningIncreaseInfo;
              that.closeIncreaseInfoAfter = that.closeIncreaseInfo;
              that.warning_line_ratio_increase_info_after = that.warning_line_ratio_increase_info.replace(/[^0-9.-]/g, '');
              that.close_line_ratio_increase_info_after = that.close_line_ratio_increase_info.replace(/[^0-9.-]/g, '');

              $(".show3Box").fadeIn(50);
            } else if (res.data.code == 0 || res.data.code == -1) {
              that.$message.error(res.data.msg);
            }
          });
      },
  },
  mounted: function () {
    let that = this;
    if (this.$store.state.loginType) {
      this.getOperate();
    }
    console.log("hey",this.changeBuyType);
  },
  watch: {
    "stockBuy.limitPrice": {
      handler: function (value) {
        let that = this;
        var str = value;
        var len1 = str.substr(0, 1);
        var len2 = str.substr(1, 1);
        //如果第一位是0，第二位不是点，就用数字把点替换掉
        if (str.length > 1 && len1 == 0 && len2 != ".") {
          str = str.substr(1, 1);
        }
        //第一位不能是.
        if (len1 == ".") {
          str = "";
        }
        //限制只能输入一个小数点
        if (str.indexOf(".") != -1) {
          var str_ = str.substr(str.indexOf(".") + 1);
          if (str_.indexOf(".") != -1) {
            str = str.substr(0, str.indexOf(".") + str_.indexOf(".") + 1);
          }
        }
        if (str.length > 10) {
          str = str.substring(0, 10);
        }

        //正则替换，保留数字和小数点
        // str = str.replace(/[^\d^\.]+/g,'');
        //如果需要保留小数点后两位，则用下面公式
        str = str.replace(/\.\d\d\d$/, "");
        that.stockBuy.limitPrice = str;
      },
    },
    "stockSell.limitPrice": {
      handler: function (value) {
        let that = this;
        var str = value;
        var len1 = str.substr(0, 1);
        var len2 = str.substr(1, 1);
        //如果第一位是0，第二位不是点，就用数字把点替换掉
        if (str.length > 1 && len1 == 0 && len2 != ".") {
          str = str.substr(1, 1);
        }
        //第一位不能是.
        if (len1 == ".") {
          str = "";
        }
        //限制只能输入一个小数点
        if (str.indexOf(".") != -1) {
          var str_ = str.substr(str.indexOf(".") + 1);
          if (str_.indexOf(".") != -1) {
            str = str.substr(0, str.indexOf(".") + str_.indexOf(".") + 1);
          }
        }
        if (str.length > 10) {
          str = str.substring(0, 10);
        }
        //正则替换，保留数字和小数点
        // str = str.replace(/[^\d^\.]+/g,'');
        //如果需要保留小数点后两位，则用下面公式
        str = str.replace(/\.\d\d\d$/, "");
        that.stockSell.limitPrice = str;
      },
    },
  },
  created() {
    let that = this;
    eventBus.$on("symbol", (symbol) => {
      that.holdBuy(symbol);
    });
  },
  beforeDestroy() {
    clearTimeout(window.timer1);
    clearTimeout(window.timer2);
    clearTimeout(window.timer3);
  },
};
</script>
<style scoped>
@import url("./../assets/css/entrust.css");
.show_content_strategynow_colored{
      background-color: #faf3e9;
      padding: 10px;
      font-size: 15px;
  }
  .show_content_strategynow{
      padding: 10px;
      font-size: 15px;
  }
  .strategynow_matching_amt{
      border: 1px solid #ccc !important; 
      width:500px !important;
      height:50px !important;
      padding-left: 25px !important;
      margin-top: 15px !important;
      margin-bottom: 15px !important;
  }
  .percentageColor{
      color:#D02E27;
  }

.submit {
  width: 100%;
}
.green {
  color: #3F7A21;
}
.redText {
  color: #D02E27;
}
.greenText {
  color: #3F7A21;
}
.red {
  color: #D02E27;
}
.text-border {
  border: 1px solid #D02E27;
  padding: 5px;
  border-radius: 10px;
}

.full_width {
  width: 100%;
}
.box-market {
  overflow: hidden;
  font-size: 14px;
  line-height: 1.5;
}
.container {
  width: 100%;
  max-width: 1200px;
  min-width: 1400px;
  margin: 10px auto;
}
/deep/.el-select-dropdown__item.selected {
    color: #0D268D;
    font-weight: 700;
}
.bottom_style{
  padding-bottom:5px;
  border-bottom: 1px solid rgb(220, 222, 224);
}
.columnDesign{
text-align: center;
border-right:1px solid rgb(220, 222, 224);
}
.columnDesign:last-child {
    border-right: none;
}
.before_table_style{
  margin-right:-15px;
  margin-left:-15px;
  padding-top: 15px;
  padding-bottom:6px;
  border-bottom:1px solid rgb(220, 222, 224);
}
.optionsBuy:hover{
  color:white;
  background-color:#d02e27 ;
  border:#d02e27;
}
.optionsBuy:focus{
  color:white;
  background-color:#d02e27 ;
  border:#d02e27;

}
.optionsSell:hover{
  color:white;
  background-color:#0D268D ;
  border:#0D268D;

}
.optionsSell:focus{
  color:white;
  background-color:#0D268D ;
  border:#0D268D;

}
</style>
<style>
.tradingChannelPop .el-dialog__body {
  padding: 0px 20px;
}

#refreshBtn .el-button--small{
  background-color: #FFF;
  border-radius: 0px;
  border: 1px solid #DCDFE6;
  padding: 12px 13px;
  font-size: 13px;
  height: 41px !important;
}
#proportion{
  border-radius: 0px !important;
  background-color: #FFF !important;
  border-right: 1px solid #DCDFE6 !important;
  border-top: 1px solid #DCDFE6 !important;
  padding: 12px 13px !important;
  font-size: 14px !important;
  height: 40px !important;
}
#capitaldatadropdown .el-select .el-input__inner {
    all: unset; 
    -webkit-appearance: none !important;
    background-color: #fff !important;
    background-image: none !important;
    border-radius: 0px !important;
    border-left: 1px solid #dcdfe6 !important;
    border-top: 1px solid #dcdfe6 !important;
    border-bottom: 1px solid #dcdfe6 !important;
    -webkit-box-sizing: border-box !important;
    box-sizing: border-box !important;
    color: #606266 !important;
    display: inline-block !important;
    font-size: inherit !important;
    height: 41px !important;
    line-height: 40px !important;
    outline: 0 !important;
    padding: 0 15px !important;
    -webkit-transition: border-color .2s cubic-bezier(.645, .045, .355, 1) !important;
    transition: border-color .2s cubic-bezier(.645, .045, .355, 1) !important;
    width: 100% !important;
}

/* .el-button--small, .el-button--small.is-round{
  padding: 12px;
  font-size: 13px;
} */

/* .tradingChannelPop .el-dialog__header {
  display: none;
} */
</style>



// WEBPACK FOOTER //
// src/components/stocktrading.vue